import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useReCaptcha } from 'vue-recaptcha-v3';

import useCadastroForm from '@/composables/useCadastroForm';
import { LoginType } from '@/models/LoginType';
import { authService, storageService } from '@/services';

const useAreaDeslogadaStore = defineStore('areaDeslogada', () => {
  const loginValue = ref('');
  const loginType = ref<LoginType>('cpf');
  const dataValue = ref('');
  const dataError = ref(false);

  const cadastroForm = useCadastroForm();

  const recaptcha = useReCaptcha();

  const verifyRecaptcha = async (action: string) => {
    if (!recaptcha) throw new Error('Erro na inicialização do recaptcha');
    await recaptcha.recaptchaLoaded();
    return recaptcha.executeRecaptcha(action);
  };

  const verifyCachedRecaptcha = async (action: string) => (
    storageService.hash.get() || verifyRecaptcha(action)
  );

  const cadastrar = async (nome?: string) => {
    const hash = await verifyCachedRecaptcha('cadastro');
    const usuarioDto = cadastroForm.getUsuarioDto(nome);
    return authService.cadastrar(usuarioDto, hash);
  };

  const reset = () => {
    loginValue.value = '';
    loginType.value = 'cpf';
    dataValue.value = '';
    dataError.value = false;

    cadastroForm.reset();
  };

  return {
    loginValue,
    loginType,
    dataValue,
    dataError,
    cadastroForm,

    cadastrar,
    verifyCachedRecaptcha,
    verifyRecaptcha,
    reset,
  };
});

export default useAreaDeslogadaStore;
